import { PRIVATE_ADMIN, PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const ADMIN_PROPOSAL_PROJECT_LIST = PRIVATE_ADMIN + "/list-proposal-project";
export const PRIVATE_PROPOSAL_PROJECT_LIST = PRIVATE_USER + "/list-proposal-project";

export const ADMIN_PROPOSAL_PROJECT_FORM = PRIVATE_ADMIN + "/form-proposal-project";
export const PRIVATE_PROPOSAL_PROJECT_FORM = PRIVATE_USER + "/form-proposal-project";



